<template>
	<div class="video-item overflow-hidden transition-shadow duration-300">
		<a :href="externalLink" target="_blank" v-if="externalLink?.length > 0">
			<div
				class="relative group image aspect-w-16 aspect-h-9 overflow-hidden rounded-lg"
			>
				<img :src="previewImageURL" class="object-cover rounded-lg" alt="" />
				<div
					class="absolute inset-0 flex items-center justify-center w-full h-full transition-colors duration-300 bg-gray-900 bg-opacity-0 group-hover:bg-opacity-40"
				>
					<div
						class="flex items-center justify-center w-8 h-8 transition duration-300 group-hover:scale-110"
					>
						<div class="play w-full h-full"></div>
					</div>
				</div>
			</div>
		</a>
		<router-link :to="url" v-if="!externalLink || externalLink?.length == 0">
			<!-- <a :href="url" aria-label="Article"> -->
			<div
				class="relative group image aspect-w-16 aspect-h-9 overflow-hidden rounded-lg"
			>
				<img :src="previewImageURL" class="object-cover rounded-lg" alt="" />
				<div
					class="absolute inset-0 flex items-center justify-center w-full h-full transition-colors duration-300 bg-gray-900 bg-opacity-0 group-hover:bg-opacity-40"
				>
					<div
						class="flex items-center justify-center w-8 h-8 transition duration-300 group-hover:scale-110"
					>
						<div class="play w-full h-full"></div>
					</div>
				</div>
			</div>
			<!-- </a> -->
		</router-link>
		<div class="pt-1 pb-1">
			<h3 class="title line-clamp-2" v-html="attributedTitle"></h3>
			<p class="desc line-clamp-2" v-if="showDesc">{{ desc }}</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		desc: String,
		title: String,
		imageURL: String,
		videoThumbnailURL: String,
		url: String,
		date: String,
		externalLink: String,
		keywords: String,
		showDesc: {
			type: Boolean,
			default: false,
		},
	},
	name: "VideoItem",
	components: {},
	data() {
		return {};
	},
	mounted() {
		// console.log(this.imageURL);
	},
	computed: {
		previewImageURL() {
			var previewURL = this.imageURL;
			if (
				previewURL?.length == 0 ||
				previewURL.endsWith("/assets/images/no-image.jpg")
			) {
				previewURL = this.videoThumbnailURL;
			}
			return previewURL;
		},
		attributedTitle() {
			let match = this.keywords?.trim();
			match = "新";
			if (match?.length > 0) {
				const regex = new RegExp("(" + match + ")", "g");
				return this.title.replace(regex, '<span class="highlight .highlight-search-result">$1</span>');
				// return this.title.replace;
			} else {
				return this.title;
			}
		},
	},
};
</script>

<style scoped>
.title {
	font-size: 13px;
	font-weight: 500;
	color: #111;
}
.desc {
	margin-top: 4px;
	font-size: 13px;
	font-weight: normal;
	line-height: 150%;
	color: #777;
}
.highlight-search-result {
	color: #cb3432 !important;
	margin: 0 1px;
}

.play {
	background-size: contain;
	background-image: url("~@/assets/images/icon-play.png");
}

img {
	background-color: lightgray;
	opacity: 0;
	border: none;
}

img[src^="http"] {
	display: block;
	background: none;
	opacity: 1;
}
img[lazy="loading"],
img[lazy="loaded"],
img[lazy="error"] {
	background-color: rgba(250, 250, 250, 20);
}

@media (min-width: 500px) {
	.title {
		font-size: 15px;
	}
	.desc {
		font-size: 14px;
	}
}
</style>
